import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { routes } from '../../utils/routes';
import Navbar from '../../common/Navbar/Navbar';
import Sidebar from 'react-sidebar';
// import withSidebar from '../../hoc/withSidebar';
// import { useState } from 'react';
import SidebarContent from '../../common/SidebarContent/SidebarContent';
import { getUser } from '../../utils/localStorage';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSidebarOpen : false,
      Pagetitle:"",
      userDetail:null
    }
    this.pageTitleInterval = null;
  }

  formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0'); // Day with leading zero
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month with leading zero
    const year = date.getFullYear(); // Full year
    return `${day}/${month}/${year}`;
  };

  checkPageTitle = (title) => 
  {
    const fromDate = localStorage.getItem("fromDate")
    const toDate = localStorage.getItem("toDate")

    console.log("Storage", fromDate);

    if(title==="/home/facilitator-actions-view-container/"||title==="/home/facilitator-actions-view-container")
    {
      this.setState({Pagetitle : "Service Follow Ups"});
    }
    else if(title==="/home/three-sixty-degree-view-new/"||title==="/home/three-sixty-degree-view-new")
    {
      this.setState({Pagetitle : "360 Degree View"});
    }
    else if(title==="/home/admin-service-progression/"||title==="/home/admin-service-progression")
    {
      this.setState({Pagetitle : "Facilitator Assignment Module"});
    }
    else if(title==="/home/partyinvoice/"||title==="/home/partyinvoice")
    {
      this.setState({Pagetitle : "Invoice Tracking"});
    }
    else if(title==="/home/jpmcdashboard/"||title==="/home/jpmcdashboard")
    {
      this.setState({Pagetitle : "JPMC Dashboard"});
    }
    else if(title==="/home/jpmcexpdashboard/"||title==="/home/jpmcexpdashboard")
      {
        this.setState({Pagetitle : "JPMC Expense Dashboard"});
      }
    else if(title==="/home/closedservice/"||title==="/home/closedservice")
    {
      this.setState({Pagetitle : "Closed Services"});
    }
    else if(title==="/home/newandengagedusers/"||title==="/home/newandengagedusers")
    {
      // this.setState({Pagetitle : "Performance Tracking of New and Engaged Users Dashboard"});
      if(fromDate && toDate){
        this.setState({Pagetitle : `Performance Tracking of New and Engaged Users Dashboard (${fromDate} - ${toDate})`});
      } else if(fromDate){
        this.setState({Pagetitle : `Performance Tracking of New and Engaged Users Dashboard (From :- ${fromDate})`});
      } else if(toDate){
        this.setState({Pagetitle : `Performance Tracking of New and Engaged Users Dashboard (Till :- ${toDate})`});
      } else {
        const currentDate = new Date();
        const pastDate = new Date();
        pastDate.setMonth(currentDate.getMonth() - 3);

        const formattedFromDate = this.formatDate(pastDate); 
        const formattedToDate = this.formatDate(currentDate);
        this.setState({Pagetitle : `Performance Tracking of New and Engaged Users Dashboard (${formattedFromDate} - ${formattedToDate})`});
      }

    }
    else if(title==="/home/admin-expert-slots/"||title==="/home/admin-expert-slots")
    {
      this.setState({Pagetitle : "Expert Calendar Slots"});
    }
    //else if(title==="/home/facilitator-service-progression/"||title==="/home/facilitator-service-progression")
    else if(title==="/home/facilitator-service-progression/"||title==="/home/facilitator-service-progression")
    {
      this.setState({Pagetitle : "Service Progression Module"});
    }
    else if (title === "/home/program-manager-master/" || title === "/home/program-manager-master") {
      this.setState({ Pagetitle: "Program Manager Master" });
    }
    else if (title === "/home/partner-master/" || title === "/home/partner-master") {
      this.setState({ Pagetitle: "Partner Master" });
    }
    else if (title === "/home/programmanager-partner-association/" || title === "/home/programmanager-partner-association") {
      this.setState({ Pagetitle: "Program Manager Partner Association" });
    }
    else if(title==="/home/service-catalogue-view/"||title==="/home/service-catalogue-view")
    {
      this.setState({Pagetitle : "Service Catalogue"});
    }
    else if(title==="/home/resource-master-view/"||title==="/home/resource-master-view")
    {
      this.setState({Pagetitle : "Resource Master"});
    }
    else if(title==="/home/manage_external_partner_view/"||title==="/home/manage_external_partner_view")
    {
      this.setState({Pagetitle : "Manage External Partner"});
    }
    else if(title==="/home/my-service-requests"||title==="/home/my-service-requests/")
    {
      this.setState({Pagetitle : "Lead Progression Module"});
    }
    else if(title==="/home/admin-service-requests"||title==="/home/admin-service-requests/")
    {
      this.setState({Pagetitle : "Handholder Assignment Module"});
    }
    else if(title==="/home/reports"||title==="/home/reports/")
    {
      this.setState({Pagetitle : "Reports"});
    }
    else if(title==="/home/payment-tracker"||title==="/home/payment-tracker/")
    {
      this.setState({Pagetitle : "Payment Settlement Report"});
    }
    else if(title==="/home/users"||title==="/home/users/")
    {
      this.setState({Pagetitle : "Manage Roles"});
    }
    else if(title==="/home/service-packaging"||title==="/home/service-packaging/")
    {
      this.setState({Pagetitle : "Offering Module"});
    }
    else if(title==="/home/spled-dashboard"||title==="/home/spled-dashboard/")
    {
      this.setState({Pagetitle : "SPLed Dashboard"});
    }
    else if(title==="/home/engagedusers-container"||title==="/home/engagedusers-container/")
    {
      this.setState({Pagetitle : "Engaged Users Dashboard"});
    }
    else if(title==="/home/assignedfacilitators-container"||title==="/home/assignedfacilitators-container")
    {
      this.setState({Pagetitle : "Assigned Facilitator Dashboard"})
    }
    else if(title==="/home/facilitator-kra-dashboard"||title==="/home/facilitator-kra-dashboard/")
    {
      this.setState({Pagetitle : "Facilitator KRA Dashboard"});
    }
    else if(title==="/home/managers-kra-dashboard"||title==="/home/managers-kra-dashboard/")
    {
      this.setState({Pagetitle : "Managers KRA Dashboard"});
    }
    else if(title==="/home/upload-kra-report"||title==="/home/upload-kra-report/")
    {
      this.setState({Pagetitle : "Upload KRA Report"});
    }
    else if(title==="/home/spled-service-requests"||title==="/home/spled-service-requests/")
    {
      this.setState({Pagetitle : "SPLed Service Requests"});
    }
    else if(title==="/home/search-user-business-profile"||title==="/home/search-user-business-profile/")
    {
      this.setState({Pagetitle : "Search User Profile"});
    }
    else if(title==="/home/mark-user-out-of-office"||title==="/home/mark-user-out-of-office/")
    {
      this.setState({Pagetitle : "Mark Out of Office"});
    }
    else if(title==="/home/sp-target-configuration"||title==="/home/sp-target-configuration/")
    {
      this.setState({Pagetitle : "Targets Configuration"});
    }
    else if(title==="/home/dnd-users"||title==="/home/dnd-users/")
    {
      this.setState({Pagetitle : "DND Users List"});
    }
    else if(title==="/home/my-resource-assignment/")
    {
      this.setState({Pagetitle : "My Resource Assignment"});
    }
    else if(title==="/home/admin-resource-request/")
    {
      this.setState({Pagetitle : "Resource Assignment"});
    }
    else if(title==="/home/facilitator-actions-view-container-new/")
    {
      this.setState({Pagetitle : "Tools Templates Followups"});
    }
    else if(title==="/home/ihcldashboard/"||title==="/home/ihcldashboard")
    {
      this.setState({Pagetitle : "IHCL Dashboard"});
    }
    else if(title==="/home/jpmc-three-sixty-degree-view/"||title==="/home/jpmc-three-sixty-degree-view")
    {
      this.setState({Pagetitle : "Jpmc 360 Degree View"});
    }
    else if(title==="/home/dreambignewandengagedusers/"||title==="/home/dreambignewandengagedusers")
      {
  
        // if(fromDate && toDate){
        //   this.setState({Pagetitle : `Performance Tracking of dreamBIG New and Engaged Users Dashboard (${fromDate} - ${toDate})`});
        // } else if(fromDate){
        //   this.setState({Pagetitle : `Performance Tracking of dreamBIG New and Engaged Users Dashboard (From :- ${fromDate})`});
        // } else if(toDate){
        //   this.setState({Pagetitle : `Performance Tracking of dreamBIG New and Engaged Users Dashboard (Till :- ${toDate})`});
        // } else {
        //   const currentDate = new Date();
        //   const pastDate = new Date();
        //   pastDate.setMonth(currentDate.getMonth() - 3);
  
        //   const formattedFromDate = this.formatDate(pastDate); // Format as DD/MM/YYYY
        //   const formattedToDate = this.formatDate(currentDate);
        //   this.setState({Pagetitle : `Performance Tracking of dreamBIG New and Engaged Users Dashboard (${formattedFromDate} - ${formattedToDate})`});
        // }
        
        this.setState({Pagetitle : `Performance Tracking of dreamBIG New and Engaged Users Dashboard`});
  
        // if(fromDate === null || toDate === null){
        //   this.setState({Pagetitle : `Performance Tracking of New and Engaged Users Dashboard`});
        // } else {
        //   this.setState({Pagetitle : `Performance Tracking of New and Engaged Users Dashboard (${fromDate} - ${toDate})`});
        // }
      }
      else if(title==="/home/jpmc-testimonials/"||title==="/home/jpmc-testimonials")
    {
      this.setState({Pagetitle : "Beneficiary's Profile"});
    }
    else 
    {
      this.setState({Pagetitle : ""});
    }
  }

  startInterval = () => {
    this.pageTitleInterval = setInterval(() => {
      this.checkPageTitle(window.location.pathname);
    }, 5000);
  };

  stopInterval = () => {
    if (this.pageTitleInterval) {
      clearInterval(this.pageTitleInterval);
      this.pageTitleInterval = null;
    }
  };

  handleRouteChange = () => {
    const path = window.location.pathname;
    if (path === "/home/newandengagedusers/" || path === "/home/newandengagedusers") {
      if (!this.pageTitleInterval) {
        this.startInterval();
      }
    } else {
      this.stopInterval();
    }
  };

  changePageTitle = (title) => {
    const {Pagetitle} = this.state;
    this.setState({Pagetitle : title});
  }

  componentDidMount() {
    const user = getUser();
    this.setState({userDetail: user})

    if(!user && !window.location.pathname.includes("/home/ihcldashboard")){
      this.props.history.push('/login');
    }

    this.checkPageTitle(this.props.history.location.pathname);
    this.handleRouteChange();

    this.props.history.listen(() => {
      this.checkPageTitle(window.location.pathname);
      this.handleRouteChange();
    })
  }

  componentWillUnmount() {
    // Clear the interval when the component is unmounted
    this.stopInterval(); 
    localStorage.removeItem("fromDate")
  }

  toggleSidebar = () => {
    const {isSidebarOpen} = this.state;
    this.setState({isSidebarOpen : !isSidebarOpen});
  }

  render() {
    return(
      <div className=''>
        <Navbar toggleSidebar={this.toggleSidebar} userDetail={this.state.userDetail}  {...this.props} Pagetitle={this.state.Pagetitle}/>
        <Sidebar
          sidebar={<SidebarContent toggleSidebar={this.toggleSidebar} changePageTitle={this.changePageTitle}/>}
          open={this.state.isSidebarOpen}
          onSetOpen={this.toggleSidebar}
          styles={{ sidebar: { background: "white" ,zIndex:"4"} ,overlay:{zIndex:"3"}}}
          pullRight
        >
          <div className="container-fluid under-nav min-vh-100" style={{backgroundColor:"white"}}>
            <div className="row">
              <div className="col-12">
                <Switch>
                  {
                    routes.map((route,i) => {
                      const Component = route.component;
                      return(
                        <Route
                          key={i}
                          exact
                          path={route.path}
                          component={Component}
                        />
                      )
                    })
                  }
                  <Route
                    path="/home"
                    render={() => <Redirect to={routes[0].path}/>}
                  />
                </Switch>
              </div>
            </div>
          </div>
        </Sidebar>
      </div>
    );
  }
}

export default Home;